<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.complaints && source && source.content">
  <app-global-locations *ngIf="logId == '' && !isForCustomer && source" [locations]="source.locations"
    (onChanged)="onLoad()"></app-global-locations>
  <div *ngIf="source.locations" class="row freeze_height">
    <div class="col-12">
      <div style="height: 10px;">&nbsp;</div>
    </div>
  </div>
  <div class="banner center" *ngIf="logId == ''">
    <div class="row freeze_height">
      <div class="col-md-8">
        <i class="material-icons" *ngIf="isForCustomer" (click)="onAction(1)"
          title="{{localService.languageContent.complaints.new_complaint}}">note_add</i>
        <label style="font-weight: normal; margin-left: 15px;" *ngIf="!isForCustomer">
          <input type="checkbox" [(ngModel)]="isShowOnlyOwnLoginAssigned" (change)="onLoad()" />
          <span class="normal_color">{{localService.languageContent.complaints.is_show_only_login_user_assinged}}</span>
        </label>
      </div>
      <div class="col-md-4">
        <ngx-select *ngIf="statuses" [(ngModel)]="filterStatus" [noAutoComplete]="true" [items]="statuses"
          [optionValueField]="'key'" [optionTextField]="'value'" (select)="onLoad()" (remove)="onLoad()"
          [allowClear]="true" placeholder="*">
        </ngx-select>
      </div>
    </div>
    <div class="row row_header freeze_height">
      <div class="col-6">
        {{localService.languageContent.complaints.title}}
      </div>
      <div class="col-3">
        {{localService.languageContent.complaints.created_on}}
      </div>
      <div class="col-3">
        {{localService.languageContent.complaints.status}}
      </div>
    </div>
    <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row styled_row freeze_col" *ngFor="let item of source.content.items">
        <div class="col-6">
          <a class="button" [routerLink]="['/complaints' + localService.basicParamsString,item.key]"><i
              class="material-icons button icon_adjust">account_tree</i></a>
          &nbsp;
          <span [ngClass]="localService.getLanguageCode(item.v6)" class="button"
            (click)="localService.showSummary(item.v4,1)">{{item.v7}}</span>
          <span>&nbsp;{{item.v1}}</span>
        </div>
        <div class="col-3">
          <span class="en">{{item.v3 | localDate}}</span>
        </div>
        <div class="col-3">
          <span>{{localService.getText(source.options,item.v2)}}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="center" style="max-width:1000px;" *ngIf="logId != ''">
    <div class="row freeze_height">
      <div class="col-md-8">
        <div *ngIf="selectedStatus != '3'">
          <i class="material-icons on_language_changed" (click)="onLoad()">replay_circle_filled</i>
          <i class="material-icons" (click)="onAction(1)"
            title="{{localService.languageContent.complaints.new_complaint}}">note_add</i>
        </div>
      </div>
      <div class="col-md-4">
        <ngx-select *ngIf="statuses" [disabled]="isForCustomer" [(ngModel)]="selectedStatus" [noAutoComplete]="true"
          [items]="statuses" [optionValueField]="'key'" [optionTextField]="'value'" (select)="onAction(2)">
        </ngx-select>
      </div>
    </div>
    <div class="row" *ngFor="let item of source.content.items" style="margin-top:5px;">
      <div class="col-1" *ngIf="item.v3 != '1'">
        &nbsp;
      </div>
      <div class="col-11">
        <div class="banner">
          <div>
            {{item.v2}}
          </div>
          <div style="text-align:right;">
            <span class="en">{{item.v1 | localDate}}&nbsp;;&nbsp;</span>
            <span [ngClass]="localService.getLanguageCode(item.v4)">{{item.v5}}</span>
          </div>
        </div>
      </div>
      <div class="col-1" *ngIf="item.v3 == '1'">
        &nbsp;
      </div>
    </div>
  </div>
  <app-paging *ngIf="logId == '' && source && source.content" [paging]="source.content.paging"
    (onPagingRefreshed)="onLoad()" [IsSimpleSearchBarReq]="!isForCustomer"
    (onCountryChanged)="onCountryUpdated($event)"></app-paging>
</div>